import { render, staticRenderFns } from "./student_cash_list.vue?vue&type=template&id=ddf74a8e&scoped=true"
import script from "./student_cash_list.vue?vue&type=script&lang=js"
export * from "./student_cash_list.vue?vue&type=script&lang=js"
import style0 from "./student_cash_list.vue?vue&type=style&index=0&id=ddf74a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf74a8e",
  null
  
)

export default component.exports